import { Grid } from "@mui/material";
import { FormTextField } from "@zfp-akademie-a-s/zfp-design/form";
import { FormNumberField } from "@zfp-akademie-a-s/zfp-design/form/number-field";
import type { InvestmentsFormType } from "Forms/Schemas/GoalsFulfillment/CurrentSolution/investmentsFormSchema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { assetAllocationFields } from "./CharacteristicsAccordion";

export const AssetAllocationFields = () => {
  const { t } = useResource();
  const { watch, trigger, control, setValue } = useFormContext<InvestmentsFormType>();

  useEffect(() => {
    const subscription = watch((values, { name }) => {
      if (name && assetAllocationFields.includes(name as any)) {
        for (const field of assetAllocationFields) {
          const value = values[field];

          if ((value as unknown) === "" || value === null || value === undefined) {
            setValue(field, 0, { shouldValidate: false });
          }
        }

        trigger(assetAllocationFields);
      }
    });

    return () => subscription.unsubscribe();
  }, [watch, trigger, setValue]);

  return (
    <Grid container spacing={Spacing.XL} mt={Spacing.XL}>
      <Grid size={8}>
        <FormTextField
          control={control}
          name="equitiesName"
          disabled
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.Equities)}
          fullWidth
        />
      </Grid>
      <Grid size={4}>
        <FormNumberField control={control} name="equities" scale={0} thousandsSeparator=" " unit="%" placeholder="0" fullWidth />
      </Grid>

      <Grid size={8}>
        <FormTextField
          control={control}
          name="bondsName"
          disabled
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.Bonds)}
          fullWidth
        />
      </Grid>
      <Grid size={4}>
        <FormNumberField control={control} name="bonds" scale={0} thousandsSeparator=" " unit="%" placeholder="0" fullWidth />
      </Grid>

      <Grid size={8}>
        <FormTextField
          control={control}
          name="commoditiesName"
          disabled
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.Commodities)}
          fullWidth
        />
      </Grid>
      <Grid size={4}>
        <FormNumberField control={control} name="commodities" scale={0} thousandsSeparator=" " unit="%" placeholder="0" fullWidth />
      </Grid>

      <Grid size={8}>
        <FormTextField
          control={control}
          name="realEstateName"
          disabled
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.RealEstate)}
          fullWidth
        />
      </Grid>
      <Grid size={4}>
        <FormNumberField control={control} name="realEstate" scale={0} thousandsSeparator=" " unit="%" placeholder="0" fullWidth />
      </Grid>

      <Grid size={8}>
        <FormTextField
          control={control}
          name="cashName"
          disabled
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.Cash)}
          fullWidth
        />
      </Grid>
      <Grid size={4}>
        <FormNumberField control={control} name="cash" scale={0} thousandsSeparator=" " unit="%" placeholder="0" fullWidth />
      </Grid>

      <Grid size={8}>
        <FormTextField
          control={control}
          name="otherName"
          disabled
          placeholder={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.Other)}
          fullWidth
        />
      </Grid>
      <Grid size={4}>
        <FormNumberField control={control} name="other" scale={0} thousandsSeparator=" " unit="%" placeholder="0" fullWidth />
      </Grid>
    </Grid>
  );
};
